import Vue from 'vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
	faCoffee,
	faUsers,
	faUser,
	faPlus,
	faSyncAlt,
	faGlobeAmericas,
	faServer,
	faHdd,
	faMapMarkedAlt,
	faCog,
	faLocationArrow,
	faSort,
	faSortNumericDown,
	faSortNumericUp,
	faSortAlphaDown,
	faSortAlphaUp,
	faSearch,
	faExternalLinkAlt,
	faPenAlt,
	faAngleLeft,
	faAngleRight,
	faTimes,
	faCheck,
	faHistory,
	faInfoCircle,
	faCheckCircle,
	faMapMarkerAlt,
	faKey,
	faAddressCard,
	faCubes,
	faStar,
	faArrowUp,
	faArrowDown,
	faCloud,
	faMinus,
	faSignInAlt,
	faSignOutAlt,
	faCamera,
	faUserCircle,
	faRandom,
	faTicketAlt,
	faArrowRight,
	faPlusCircle,
	faArrowAltCircleUp,
	faArrowAltCircleDown,
	faUserCog,
	faTimesCircle,
	faBars,
	faCogs,
	faBell,
	faIndustry,
	faBox,
	faScrewdriver,
	faPencilAlt,
	faCalendarCheck,
	faCalendarTimes,
	faUndo,
	faSatelliteDish,
	faClock,
	faPaperPlane,
	faMap,
	faRoute,
	faMapPin,
	faStopwatch,
	faComment,
	faPlaneDeparture,
	faCalendarDay,
	faMicrochip,
	faArrowLeft,
	faExclamationCircle,
	faSadTear,
	faSatellite,
	faAngleUp,
	faAngleDown,
	faDownload,
	faCompass,
	faPaperclip,
	faUpload

} from '@fortawesome/free-solid-svg-icons'

import {
	faTrashAlt,
	faCircle,
	faDotCircle,
	faArrowAltCircleRight,
	faCopy
} from '@fortawesome/free-regular-svg-icons'

library.add(faCoffee,
	faUsers,
	faUser,
	faPlus,
	faSyncAlt,
	faGlobeAmericas,
	faServer,
	faHdd,
	faMapMarkedAlt,
	faCog,
	faLocationArrow,
	faSort,
	faSortAlphaDown,
	faSortAlphaUp,
	faSortNumericDown,
	faSortNumericUp,
	faSearch,
	faExternalLinkAlt,
	faPenAlt,
	faAngleLeft,
	faAngleRight,
	faTimes,
	faCheck,
	faTrashAlt,
	faHistory,
	faInfoCircle,
	faCircle,
	faCheckCircle,
	faMapMarkerAlt,
	faKey,
	faAddressCard,
	faCubes,
	faStar,
	faAngleLeft,
	faArrowUp,
	faArrowDown,
	faArrowLeft,
	faArrowRight,
	faCloud,
	faMinus,
	faSignInAlt,
	faSignOutAlt,
	faDotCircle,
	faCamera,
	faUserCircle,
	faRandom,
	faArrowRight,
	faTicketAlt,
	faPlusCircle,
	faArrowAltCircleUp,
	faArrowAltCircleDown,
	faUserCog,
	faTimesCircle,
	faBars,
	faCogs,
	faBell,
	faIndustry,
	faBox,
	faScrewdriver,
	faPencilAlt,
	faCalendarTimes,
	faCalendarCheck,
	faUndo,
	faSatelliteDish,
	faClock,
	faPaperPlane,
	faMap,
	faRoute,
	faMapPin,
	faStopwatch,
	faComment,
	faPlaneDeparture,
	faBell,
	faCalendarDay,
	faMicrochip,
	faExclamationCircle,
	faSadTear,
	faSatellite,
	faArrowAltCircleRight,
	faAngleUp,
	faAngleDown,
	faDownload,
	faCircle,
	faCopy,
	faCompass,
	faPaperclip,
	faUpload
)

//<fa-icon class="float-right" icon="users"/>

Vue.component('fa-icon', FontAwesomeIcon)



// WEBPACK FOOTER //
// ./src/config/fontawesome.js